"use client";

import { SpeedInsights as VercelSpeedInsights } from "@vercel/speed-insights/next";
import { isProductionTelemetryEnabled } from "../../telemetry";
import { useConsentCategory } from "../store";

/**
 * SpeedInsights - Gated behind analytics consent
 * Only loads Vercel Speed Insights when user consents to analytics cookies
 */
export function GatedSpeedInsights() {
  const analyticsConsented = useConsentCategory("analytics");

  if (!(isProductionTelemetryEnabled() && analyticsConsented)) {
    return null;
  }

  return <VercelSpeedInsights />;
}
